import * as React from "react";
import { FormControl, LinearProgress, MenuItem, Select } from "@mui/material";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { ACTUALIZAR_LISTA, OPEN_REDUX } from "../../../../redux/constanst";
import Swal from "sweetalert2";
import { handleUpdateNumber, hosting } from "../../models/buscar";

export default function AddEditTarifa(props) {
  const { datos, add, btnLabel } = props;
  const { actualizarLista, openRedux } = useSelector(
    (state) => state.userState
  );
  const dispatch = useDispatch();
  const [cost, setCost] = React.useState(datos?.cost || "");
  const [formDisabled, setFormDisabled] = React.useState(false);
  const [preSelect, setPreSelect] = React.useState(datos || []);
  const [tarifas, setTarifas] = React.useState([]);



  const enviar = async (data) => {
    data.preventDefault();
    setFormDisabled(true);
    const id = tarifas.find(datos2 => datos2.name === preSelect.name)
    axios
      .get(
        `${hosting}/mimegacall/api/addEdit_tarifa.php?id_user=${add}&ratesid=${
          datos?.ratesid
        }&name=${id.id}&cost=${cost.replace(",", ".")}`
      )
      .then((response) => {
        setFormDisabled(false);
        dispatch({ type: ACTUALIZAR_LISTA, actualizarLista: !actualizarLista });
        Swal.fire(response.data.mensaje, ``, response.data.type).then(
          (result) => {
            dispatch({
              type: ACTUALIZAR_LISTA,
              actualizarLista: !actualizarLista,
            });
          }
        );
        dispatch({ type: OPEN_REDUX, openRedux: !openRedux });
      })
      .catch(function (error) {
        console.log(error);
      });

    data.preventDefault();
  };

  const selectTarifasAdmin = () => {
    axios
      .get(`${hosting}/mimegacall/api/select_tarifas_minuto_admin.php`)
      .then((response) => {
        setTarifas(Object.values(response.data));
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  React.useEffect(() => {
    selectTarifasAdmin();
  }, []);

  return (
    <Paper sx={{ margin: "auto", overflow: "hidden" }}>
      <form onSubmit={(e) => enviar(e)}>
        <Grid
          style={{ padding: "20px" }}
          container
          spacing={0}
          alignItems="center"
        >
          <Grid item xs={12} md={4}>
            <FormControl sx={{ m: 1, width: "99.5%" }} variant="outlined">
              {/* <TextField
                id="name"
                label="Nombre tarifa"
                defaultValue={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                required
                disabled={formDisabled}
              /> */}
              <Select
                value={preSelect}
                style={{
                  width: "100%",
                  color: "black",
                }}
                disabled={btnLabel === "Editar tarifa"}
                renderValue={(value) => `${value.name}`}
                id="name"
                onChange={(e) => {
                  /* SetDatosAll({
                          ...datosAll,
                          name: e.target.value,
                        }); */
                  setPreSelect(e.target.value);
                }}
                onKeyDown={(e) => {
                  /* handleUpdateNumber(e); */
                }}
              >
                {tarifas.map((dato) => (
                  <MenuItem id="name" value={dato}>
                    {dato.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl sx={{ m: 1, width: "99%" }} variant="outlined">
              <TextField
                id="prefix"
                type={"text"}
                label={preSelect.prefix ? '' : 'Prefijo'}
                value={preSelect.prefix}
                required
                /* onChange={(e) => {
                  setPref(e.target.value)
                }} */
                disabled={true}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl sx={{ m: 1, width: "99%" }} variant="outlined">
              <TextField
                id="cost"
                type={"text"}
                label="Cost"
                defaultValue={cost.replace(".", ",")}
                onLoad={(e) => {}}
                required
                onChange={(e) => {
                  setCost(e.target.value);
                }}
                onKeyDown={(e) => handleUpdateNumber(e, cost, setCost)}
                disabled={formDisabled}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl sx={{ m: 1, width: "99.5%" }} variant="outlined">
              {!formDisabled ? (
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ mr: 1 }}
                  disabled={formDisabled}
                >
                  Guardar
                </Button>
              ) : (
                <LinearProgress />
              )}
            </FormControl>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
}
